import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, publishLast, refCount} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DataRevisionRequestData } from './data-revision-info';
import { dataMember, typedArray, deserialize, required } from 'santee-dcts';
import { Settings } from '../../core/settings';

@Injectable()
export class DataRevisionStorage {
    constructor(
        private readonly http: HttpClient,
        private settings: Settings,
    ) { }

    public loadDataRevision(datarevision: DataRevisionRequestData): Observable<DataRevisionData[]> {
        return this.http
            .post<DataRevisionModel>(`${this.settings.apiUrl}/test-result/getdatarevision`, datarevision)
            .pipe(map(result => deserialize(result, DataRevisionModel).results));
    } 
}
export class DataRevisionData {
    @dataMember()
    @required()
    public labTestId: number;
    @dataMember()
    @required()
    public column: string;
    @dataMember()
    @required({ nullable: true })
    public revisedFrom: string;
    @dataMember()
    @required({ nullable: true })
    public revisedTo: string;
    @dataMember()
    @required({ nullable: true })
    public changedDate: any;
    @dataMember()
    @required({ nullable: true })
    public protocol: any;
    @dataMember()
    @required({ nullable: true })
    public investigatornumber: any;
}
export class DataRevisionModel {
    @dataMember()
    @typedArray(DataRevisionData)
    public results: DataRevisionData[];
}